<template>
  <!-- start: page footer -->
  <div class="main-footer mt-5">
    <span>&copy; 2023. Dashbyte. All Rights Reserved.</span>
    <span>Created by: <a href="https://themepixels.me" target="_blank">Themepixels</a></span>
  </div><!-- main-footer -->
</template>

<script>
export default {
  name: "Footer"
}
</script>

<style scoped>

</style>
